var Works = (function () {

  function _deleteObject(ids) {
    return $.ajax({
      url: Url.action('api/works'),
      type: 'DELETE',
      dataType: 'json',
      data: { ids: ids }
    })
    .done((notDeletedIds) => {
        _refreshTable(true, ids);

        var workIds = [];
        if (notDeletedIds && notDeletedIds.length > 0) {
            notDeletedIds.forEach(function (id) {
                if (workIds.indexOf(id) === -1) {
                    workIds.push(id);
                }
            });
        }

        if (workIds.length > 0) {
            ModalConductor.activate(WorkErrorAcceptanceModal, $('#error-operation-tmpl').text(), 'Внимание!', 'не были удалены', workIds);
        }

    });
  };

  function _delete(ids) {
    if (ids.length > 1) {
      alert('Нельзя удалить удалить одновременно более одной записи!');
      return;
    }
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      _deleteObject(ids);
    }
  };

  // Функция открытия формы просмотра
  function _show(id) {
    $('#transportLocationReport').html('');
    $('#transportLocationReportEdit').html('');

    var modal = ModalConductor.activate(WorkViewModal, id,
      (workId) => {
        _deleteObject([workId]).done(() => {
          modal.close();
        });
      },
      _refreshTable)
      .on('closed', (modalResult) => {
        // Обновляем данные таблицы (необходимо для актуализации данных о расчете коэффициента)
        _refreshTable();
      });
  }

  function _add() {
    $('#transportLocationReport').html('');
    $('#transportLocationReportEdit').html('');

    ModalConductor.activate(WorkEditModal).on('closed', (modalResult) => {

        function afterSave(modalResult) {
            var workId = modalResult.data.id;
            if (modalResult.data.canAutoUpdate) {
                var status = modalResult.data.status;
                ModalConductor.activate(WorkAutoStatusModal, workId, status).on('closed', (modalResult) => {
                    var modal = ModalConductor.activate(WorkViewModal, workId,
                        (workId) => {
                            _deleteObject([workId]).done(() => {
                                modal.close();
                            });
                        });
                });
            } else {
                var modal = ModalConductor.activate(WorkViewModal, workId,
                    (workId) => {
                        _deleteObject([workId]).done(() => {
                            modal.close();
                        });
                    });
            }
        }


        if (modalResult.ok) {
        _refreshTable();
        var workId = modalResult.data.id;
        if (modalResult.data.boundaryChanged) {
            ModalConductor.activate(MessageModal, $('#message-tmpl').text(), 'Внимание!', 'Границы Работы сопоставлены с Участком обслуживания')
                .on('closed', (mr) => { afterSave(modalResult); });
        } else {
            afterSave(modalResult);
        }
      }
    });
  }

    function _refreshTable(resetChecked, deselectOnlyIds) {
        var table = $('#WorkListItemViewModelTable').DataTable();
        refreshTable(table, resetChecked, true, deselectOnlyIds);
    };

  return {
    add: _add,
    show: _show,
    del: _delete
  };
}());
